module.exports = __webpack_public_path__ + "static/QuickTaskicon-9923c1ab262bd9d96ebc3b9385c8f9e2.png";